import { createSlice } from "@reduxjs/toolkit"
import { usersApiSlice } from '../users/usersApiSlice';
import { apiSlice } from "../../app/apiSlice";
const authSlice = createSlice({
  name: 'auth',
  initialState: { currentUser: null, token: null, is_paid: false, phoneNumber: "", needsProfileCompletion: false },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, is_paid, needsProfileCompletion, ...user } = action.payload || {}
      // Behåll tidigare data men skriv över med nytt
      state.currentUser = { ...(state.currentUser || {}), ...user, is_paid }
      state.token = accessToken || null
      state.is_paid = is_paid ?? state.is_paid
      state.needsProfileCompletion = !!needsProfileCompletion
    },
    logOut: (state, action) => {
      state.currentUser = null
      state.token = null
      state.is_paid = false
      state.phoneNumber = ""
      state.needsProfileCompletion = false
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload;
    },
    setNeedsProfileCompletion: (state, action) => {
      state.needsProfileCompletion = !!action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      usersApiSlice.endpoints.updateUser.matchFulfilled,
      (state, action) => {
        // Uppdatera user men rör inte token eller needsProfileCompletion
        state.currentUser = { ...(state.currentUser || {}), ...action.payload }
        state.is_paid = action.payload?.is_paid ?? state.is_paid
      }
    );

    builder.addMatcher(
      usersApiSlice.endpoints.getUserMe.matchFulfilled,
      (state, action) => {
        // Keep auth user in sync with server (important after payment/renewal)
        state.currentUser = { ...(state.currentUser || {}), ...(action.payload || {}) }
        state.is_paid = action.payload?.is_paid ?? state.is_paid
      }
    );
  },
})

export const { setCredentials, logOut, updateUser, setPhoneNumber, setNeedsProfileCompletion } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state) => state.auth.currentUser
export const selectCurrentToken = (state) => state.auth.token
export const selectIsUserPremium = (state) => state.auth.currentUser?.is_paid ?? false;
export const selectNeedsProfileCompletion = (state) => state.auth.needsProfileCompletion;

export const logoutAndInvalidateCache = () => (dispatch) => {
  dispatch(logOut());
  dispatch(apiSlice.util.resetApiState());
};